import '../../styles/hero.css'
import smartsenLogo from '../../images/logo.png'
import submarine from '../../images/submarine.png'
import submarineDrone from '../../images/submarine_drone.png'
import sky_drone from '../../images/sky_drone.png'
import earth from '../../images/earth.png'

export default function Hero() {
  return (
    <section className='hero_section' id='home'>
        <div className="container" style={{marginTop: '10%'}}>
            <div className="hero_wrapper">
                <div className="hero_content">
                    <div className='hero_text'>
                        <h2 className="highlight">info@SmartSen.Co</h2>
                        <h4>Feel safer and more at ease with SmartSen sensors providing protection all around you</h4>
                        <p>Detecting & tracking incoming threat</p>
                        <span className="advisory-board-line">
                            <i className="ri-corner-down-right-line advisory-board-arrow"></i>
                            even small-scale vessels/drones
                        </span>
                        <p>Detecting the accurate location of an approaching threat & continuous tracking with Q-MAG of <span className='logo-wrapper'><img className='smartsen-logo' src={smartsenLogo} alt="smartsen-logo" /></span></p>
                    </div>
                    <div className="hero_btns">
                        <a href='#about' className="primary_btn">Learn More</a>
                        <a href='#contact' className="secondary_btn">Contact Us</a>
                    </div>
                </div>
                <div className="hero_img">
                    <img src={earth} alt="earth" className="main-image" />
                    <div className="sensor-images">
                        <div className="sensor-item">
                            <img src={submarine} alt="submarine" />
                        </div>
                        <div className="sensor-item middle">
                            <img src={submarineDrone} alt="submarine drone" />
                        </div>
                        <div className="sensor-item">
                            <img src={sky_drone} alt="sky drone" />
                        </div>
                    </div>
                    <p className="sensor-label">for short/near field sensors (up to 500m)</p>
                </div>
            </div>
        </div>
    </section>
  )
}